/**
 * midiLabels
 *
 * Pure formatting helpers — no Vue, no side effects.
 *
 * Builds a human-readable label for a MIDI CC stream, optionally looking up
 * device and CC names from the app's settings.devices array.
 *
 * @param {number}      channel  1-indexed MIDI channel
 * @param {number}      cc       CC number (0–127)
 * @param {Array|null}  devices  settings.devices array (may be null/undefined)
 * @returns {string}             e.g. "Ch 1 (Reverb) · CC 91 (Decay)"
 */
export function formatStreamLabel(channel, cc, devices) {
  const device     = devices?.[channel - 1];
  const deviceName = device?.name?.trim()   || null;
  const ccName     = device?.cc?.[cc]?.trim() || null;

  const chPart = deviceName ? `Ch ${channel} (${deviceName})` : `Ch ${channel}`;
  const ccPart = ccName     ? `CC ${cc} (${ccName})`          : `CC ${cc}`;

  return `${chPart} · ${ccPart}`;
}
